if (!customElements.get('ta-legacy-product-tabs')) {
  customElements.define('ta-legacy-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next, true);
        });
      });
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
    }
  });
}

(() => {

        class Star {
            constructor(id, x, y) {
                this.id = id;
                this.x = x;
                this.y = y;
                this.r = Math.floor(Math.random() * 2) + 1;
                const alpha = (Math.floor(Math.random() * 10) + 1) / 10 / 2;
                this.color = `rgba(255,255,255,${alpha})`;
            }

            draw() {
                ctx.fillStyle = this.color;
                ctx.shadowBlur = this.r * 2;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
                ctx.closePath();
                ctx.fill();
            }

            move() {
                this.y -= 0.15;
                if (this.y <= -10) this.y = HEIGHT + 10;
                this.draw();
            }

            die() {
                stars[this.id] = null;
                delete stars[this.id];
            }
        }

        class Dot {
            constructor(id, x, y) {
                this.id = id;
                this.x = x;
                this.y = y;
                this.r = Math.floor(Math.random() * 5) + 1;
                this.maxLinks = 2;
                this.speed = 0.5;
                this.a = 0.5;
                this.aReduction = 0.005;
                this.color = `rgba(255,255,255,${this.a})`;
                this.linkColor = `rgba(255,255,255,${this.a / 4})`;
                this.dir = Math.floor(Math.random() * 140) + 200;
            }

            draw() {
                ctx.fillStyle = this.color;
                ctx.shadowBlur = this.r * 2;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
                ctx.closePath();
                ctx.fill();
            }

            link() {
                if (this.id === 0) return;
                const previousDot1 = getPreviousDot(this.id, 1);
                const previousDot2 = getPreviousDot(this.id, 2);
                const previousDot3 = getPreviousDot(this.id, 3);
                if (!previousDot1) return;
                ctx.strokeStyle = this.linkColor;
                ctx.moveTo(previousDot1.x, previousDot1.y);
                ctx.beginPath();
                ctx.lineTo(this.x, this.y);
                if (previousDot2) ctx.lineTo(previousDot2.x, previousDot2.y);
                if (previousDot3) ctx.lineTo(previousDot3.x, previousDot3.y);
                ctx.stroke();
                ctx.closePath();
            }

            move() {
                this.a -= this.aReduction;
                if (this.a <= 0) {
                    this.die();
                    return;
                }
                this.color = `rgba(255,255,255,${this.a})`;
                this.linkColor = `rgba(255,255,255,${this.a / 4})`;
                this.x += Math.cos(degToRad(this.dir)) * this.speed;
                this.y += Math.sin(degToRad(this.dir)) * this.speed;
                this.draw();
                this.link();
            }

            die() {
                dots[this.id] = null;
                delete dots[this.id];
            }
        }

        function getPreviousDot(id, stepback) {
            if (id === 0 || id - stepback < 0) return false;
            return dots[id - stepback] !== undefined ? dots[id - stepback] : false;
        }

        const canvas = document.querySelector('[data-legacy-product-background]');
        if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        let animationFrame;
        let WIDTH, HEIGHT;
        let mouseMoving = false, mouseMoveChecker, mouseX, mouseY;
        const stars = [];
        const initStarsPopulation = 80;
        const dots = [];
        const dotsMinDist = 2;
        const maxDistFromCursor = 50;

        function setCanvasSize() {
            WIDTH = document.documentElement.clientWidth;
            HEIGHT = document.documentElement.clientHeight;
            canvas.setAttribute("width", WIDTH);
            canvas.setAttribute("height", HEIGHT);
        }

        function init() {
            ctx.strokeStyle = "white";
            ctx.shadowColor = "white";
            for (let i = 0; i < initStarsPopulation; i++) {
                stars[i] = new Star(i, Math.floor(Math.random() * WIDTH), Math.floor(Math.random() * HEIGHT));
            }
            ctx.shadowBlur = 0;
            animate();
        }

        function animate() {
            ctx.clearRect(0, 0, WIDTH, HEIGHT);
            stars.forEach(star => star.move());
            dots.forEach(dot => dot.move());
            drawIfMouseMoving();
            animationFrame = requestAnimationFrame(animate);
        }

        window.addEventListener('mousemove', function (e) {
            mouseMoving = true;
            mouseX = e.clientX;
            mouseY = e.clientY;
            clearTimeout(mouseMoveChecker);
            mouseMoveChecker = setTimeout(() => mouseMoving = false, 100);
        }, { passive: true });

        function drawIfMouseMoving() {
            if (!mouseMoving) return;

            if (dots.length === 0) {
                dots.push(new Dot(0, mouseX, mouseY));
                dots[0].draw();
                return;
            }

            const previousDot = getPreviousDot(dots.length, 1);
            if (!previousDot) return;
            const prevX = previousDot.x;
            const prevY = previousDot.y;

            const diffX = Math.abs(prevX - mouseX);
            const diffY = Math.abs(prevY - mouseY);

            if (diffX < dotsMinDist || diffY < dotsMinDist) return;

            const xVariation = (Math.random() > 0.5 ? -1 : 1) * (Math.floor(Math.random() * maxDistFromCursor) + 1);
            const yVariation = (Math.random() > 0.5 ? -1 : 1) * (Math.floor(Math.random() * maxDistFromCursor) + 1);

            const newDot = new Dot(dots.length, mouseX + xVariation, mouseY + yVariation);
            dots.push(newDot);
            newDot.draw();
            newDot.link();
        }

        function degToRad(deg) {
            return deg * (Math.PI / 180);
        }

        window.addEventListener('resize', setCanvasSize, { passive: true });
        window.addEventListener('pagehide', () => {
            cancelAnimationFrame(animationFrame);
            clearTimeout(mouseMoveChecker);
        }, { once: true });
        setCanvasSize();
        init();
    
})();
